/**
 * Footer component with branding and links
 */

import { Link } from 'react-router-dom';
import { Separator } from '@/components/ui/separator';

export function Footer() {
  return (
    <footer className="border-t bg-background/95 backdrop-blur">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="h-8 w-8 rounded-lg bg-gradient-primary flex items-center justify-center">
                <span className="text-white font-bold text-sm">AI</span>
              </div>
              <div className="flex flex-col">
                <span className="font-semibold text-foreground">GenAI Hub</span>
                <span className="text-xs text-muted-foreground">Intel & Dell</span>
              </div>
            </div>
            <p className="text-sm text-muted-foreground">
              Enterprise-grade AI infrastructure solutions for on-premises deployment.
            </p>
          </div>

          {/* Tools */}
          <div>
            <h3 className="font-semibold mb-4">Tools</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link to="/wizard" className="hover:text-foreground transition-colors">
                  Configuration Wizard
                </Link>
              </li>
              <li>
                <Link to="/sizing" className="hover:text-foreground transition-colors">
                  Infrastructure Sizing
                </Link>
              </li>
              <li>
                <Link to="/cost-simulator" className="hover:text-foreground transition-colors">
                  Cost Simulator
                </Link>
              </li>
              <li>
                <Link to="/demos" className="hover:text-foreground transition-colors">
                  Live Demos
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-semibold mb-4">Resources</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link to="/models" className="hover:text-foreground transition-colors">
                  Model Catalog
                </Link>
              </li>
              <li>
                <Link to="/containers" className="hover:text-foreground transition-colors">
                  Container Images
                </Link>
              </li>
              <li>
                <Link to="/collateral" className="hover:text-foreground transition-colors">
                  Documentation
                </Link>
              </li>
              <li>
                <Link to="/installer" className="hover:text-foreground transition-colors">
                  Custom Installer
                </Link>
              </li>
            </ul>
          </div>

          {/* Partners */}
          <div>
            <h3 className="font-semibold mb-4">Powered By</h3>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="h-10 w-24 bg-muted rounded flex items-center justify-center text-xs font-semibold">
                  Intel
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="h-10 w-24 bg-muted rounded flex items-center justify-center text-xs font-semibold">
                  Dell
                </div>
              </div>
            </div>
          </div>
        </div>

        <Separator className="my-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
          <p>© {new Date().getFullYear()} GenAI Inference Hub. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="#" className="hover:text-foreground transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-foreground transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
